export default {
  THEME_FILE: '/assets/default.css',
  LOGO_PATH: '/assets/aer_logo.svg',
};
